<template>
  <!-- Editor layout now handled globally in App.vue grid; this view acts as a pass-through. -->
  <div class="editor-view-placeholder" />
</template>

<script setup lang="ts">
// Intentionally blank: components moved to App.vue grid areas.
</script>

<style scoped>
.editor-view-placeholder { display:none; }
</style>
